const isSubsequentVisit = 'betBuilderIsSubsequentVisit';

export function getIsSubsequentVisit() {
    const raw = localStorage.getItem(isSubsequentVisit);
    return !!raw;
}

export function setIsSubsequentVisit() {
    localStorage.setItem(isSubsequentVisit, '1');
}

const isPromoBannerDismissed = 'betBuilderIsPromoBannerDismissed';

export function getIsPromoBannerDismissed(): boolean {
    const raw = localStorage.getItem(isPromoBannerDismissed);
    return Boolean(raw);
}

export function setIsPromoBannerDismissed(): void {
    localStorage.setItem(isPromoBannerDismissed, '1');
}

export function getIsDismissed(key: string): boolean {
    const raw = localStorage.getItem(key);
    return Boolean(raw);
}

export function setIsDismissed(key: string): void {
    localStorage.setItem(key, '1');
}
